// src/components/Layout.jsx
import { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const ALL_NAV = [
{ label: 'Dashboard', path: '/dashboard', icon: '📊', permission: null },
{ label: 'Empleados', path: '/empleados', icon: '👤', permission: 'canViewEmployees' },
{ label: 'Puestos', path: '/puestos', icon: '📍', permission: 'canViewPuestos' },
{ label: 'Horarios', path: '/horarios', icon: '🗓️', permission: 'canViewSchedules' },
{ label: 'Vacantes', path: '/vacantes', icon: '🔔', permission: 'canViewVacantes' },
  { label: 'Documentos', path: '/documentos', icon: '📄', permission: 'canDownloadWorkPlans' },
{ label: 'Citas', path: '/citas', icon: '📋', permission: 'canViewCitas' },
{ label: 'Configuracion', path: '/settings', icon: '⚙️', permission: 'canManageRoles' },
  { label: 'Dashboard Asistencia', path: '/admin/asistencia', icon: '\u{1F553}', permission: 'canViewAsistencia' },
  { label: 'Dispositivos', path: '/dispositivos', icon: '\u{1F4F1}', permission: 'canManageDevices' },
];

export default function Layout({ children }) {
const { user, logout, can, getApprovalRequestsList } = useAuth();
const navigate = useNavigate();
const [collapsed, setCollapsed] = useState(false);
const [pendingCount, setPendingCount] = useState(0);

useEffect(() => {
// getApprovalRequestsList es async (Supabase) - manejar como Promise
const countPending = async () => {
if (can && can('canApproveChanges')) {
try {
const reqs = getApprovalRequestsList ? await getApprovalRequestsList() : [];
const arr = Array.isArray(reqs) ? reqs : [];
setPendingCount(arr.filter(r => r.status === 'pending').length);
} catch(e) { setPendingCount(0); }
}
};
countPending();
window.addEventListener('ggpc_approval_added', countPending);
window.addEventListener('ggpc_approval_updated', countPending);
return () => {
window.removeEventListener('ggpc_approval_added', countPending);
window.removeEventListener('ggpc_approval_updated', countPending);
};
}, [can, getApprovalRequestsList]);

const handleLogout = () => { logout(); navigate('/login'); };

// Filter nav items based on user permissions
const visibleNav = ALL_NAV.filter(n => !n.permission || (can && can(n.permission)));

return (
<div style={{ display:'flex', minHeight:'100vh', background:'#0d0d0d', fontFamily:"'Segoe UI',sans-serif" }}>
<div style={{ width: collapsed ? 60 : 220, minHeight:'100vh', background:'#111', borderRight:'1px solid #222', display:'flex', flexDirection:'column', transition:'width 0.2s', flexShrink:0, position:'relative', zIndex:10 }}>
<div style={{ padding:'1rem', borderBottom:'1px solid #222', display:'flex', alignItems:'center', gap:10 }}>
<img src="/Logo_de_GGPC-removebg-preview.png" alt="GGPC" style={{ width:36, height:36, flexShrink:0 }} onError={e=>e.target.style.display='none'} />
{!collapsed && <span style={{ color:'#F5C518', fontWeight:800, fontSize:13, letterSpacing:1 }}>GGPC</span>}
</div>
<button onClick={()=>setCollapsed(!collapsed)} style={{ background:'none', border:'none', color:'#666', cursor:'pointer', padding:'8px', textAlign:'center', fontSize:16 }}>
{collapsed ? '>' : '<'}
</button>
<nav style={{ flex:1, padding:'0.5rem 0' }}>
{visibleNav.map(n => (
<NavLink key={n.path} to={n.path} style={({ isActive }) => ({
display:'flex', alignItems:'center', gap:12, padding:'10px 16px',
color: isActive ? '#F5C518' : '#aaa', textDecoration:'none',
background: isActive ? 'rgba(245,197,24,0.1)' : 'transparent',
borderLeft: isActive ? '3px solid #F5C518' : '3px solid transparent',
fontSize:14, fontWeight: isActive ? 600 : 400, transition:'all 0.15s',
whiteSpace:'nowrap', overflow:'hidden',
})}>
<span style={{ fontSize:14, flexShrink:0, fontWeight:700 }}>{n.icon}</span>
{!collapsed && (
<span style={{ display:'flex', alignItems:'center', gap:6 }}>
{n.label}
{n.path === '/settings' && pendingCount > 0 && (
<span style={{ background:'#ef4444', color:'#fff', borderRadius:10, padding:'1px 6px', fontSize:10, fontWeight:700 }}>{pendingCount}</span>
)}
</span>
)}
</NavLink>
))}
</nav>
<div style={{ padding:'1rem', borderTop:'1px solid #222' }}>
{!collapsed && (
<div style={{ marginBottom:8 }}>
<div style={{ color:'#aaa', fontSize:12 }}>{user?.name}</div>
<div style={{ fontSize:10, color:'#555', marginTop:2, textTransform:'uppercase', letterSpacing:1 }}>{user?.role}</div>
</div>
)}
<button onClick={handleLogout} style={{ width:'100%', padding:'8px', background:'rgba(220,38,38,0.1)', border:'1px solid rgba(220,38,38,0.3)', borderRadius:6, color:'#f87171', cursor:'pointer', fontSize:12 }}>
{collapsed ? 'X' : 'Cerrar sesion'}
</button>
</div>
</div>
<div style={{ flex:1, overflow:'auto', padding:'2rem', minWidth:0 }}>
{children}
</div>
</div>
);
}
